<template>
  <accordion :id="accordionId" :group="accordionGroup">
    <template v-slot:trigger>
      <span class="icon-warning sw--margin-right-3 sw--font-size-20"></span>
      <span>Cancel order item</span>
    </template>
    <template v-slot:target>
      <div class="sw--margin-left-7 sw--margin-left-0--tab sw--margin-bottom-2 sw-dms--color-grey-46">
        No problem! Simply take no action, and your order will be canceled in 7 days. If you would like to cancel
        sooner, please click on the following link.
      </div>
      <div class="sw--margin-bottom-7 sw--margin-left-7 sw--margin-left-0--tab">
        <div v-if="errorMessage"
             class="model-fix-pita-error-message
            sw-grid-flex__cell
            sw-grid-flex
            sw-grid-flex--align-center
            sw--padding-4
            sw--bg-alert-red-lightest
            sw--border-radius-3
            sw--margin-vert-2">
          <div class="icon-how-it-works sw--font-size-28 sw--margin-right-3 sw--text-red"></div>
          <div>
            {{ errorMessage }}
          </div>
        </div>
        <a class="sw-dms__link--underlined" @click.prevent="displayModal(modalText)">
          <span class="sw-dms--color-grey-46">Cancel order item</span>
        </a>
      </div>
    </template>
  </accordion>
</template>

<script>
  import VueJQueryMixin from 'js/lib/vue/mixins/vue-jquery-mixin';
  import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
  import confirmTemplate
    from 'rrViewComponents/Model/Fix/ModelFixCancelOrderItemsComponent/confirm-cancel-order-items-noty.mustache';
  import Accordion from "rrViewComponents/Accordion/Accordion";

  export default {
    name: 'model-fix-cancel-order',

    mixins: [VueJQueryMixin, VueSwMixin],

    components: {Accordion},

    props: {
      url: {
        type: String,
        required: true
      },
      accordionId: {
        type: String,
        required: true
      },
      accordionGroup: {
        type: String,
        required: true
      }
    },

    data: () => ({
      modalText: 'Are you sure you would like to cancel this order item? The rest of this order will continue in production.',
      errorMessage: null
    }),

    // TODO: same code as in model-fix-pita, refactor when we know how to pass more than one var to noty
    methods: {
      displayModal(content) {
        const _this = this;
        this.errorMessage = null;
        let confirmed = false;
        let $confirmBtn = null;
        _this.$sw.notifications.full(content, {
          modal: true,
          layout: 'center',
          template: confirmTemplate,
          closeWith: ['button', 'backdrop'],
          showCloseButton: true,
          callback: {
            afterShow: function () {
              $confirmBtn = _this.$jQuery('[data-sw-noty-confirm-btn]');
              $confirmBtn.on('click', function () {
                confirmed = true;
              })
            },
            afterClose: function () {
              if ($confirmBtn) {
                $confirmBtn.off('click');
              }
              if (confirmed) {
                _this.submitModal();
              }
            }
          }
        });
      },
      submitModal() {
        const _this = this;
        this.$jQuery.ajax({
          type: 'POST',
          url: _this.url,
          dataType: 'json',
          success: (data) => {
            _this.$emit('success', data);
          },
          error: (jqXHR) => {
            const response = JSON.parse(jqXHR.responseText);
            _this.errorMessage = response.message;
            _this.$emit('error', jqXHR);
          }
        });
      }
    }
  }
</script>
